export default "__VITE_ASSET__Ct7CaTzw__"